import { PeriodType } from '@shopify-multiseller/graphql/partner/types';

/**
 * The window a number was measured over, said as the window it actually is.
 * "Last Month" for a rolling 30 days invited the reading "June" — these are
 * relative ranges ending today, and the label now says so.
 */
export const getPeriodText = (periodType: PeriodType): string => {
  switch (periodType) {
    case PeriodType.Today:
      return 'Today';
    case PeriodType.Last_7Days:
      return 'Last 7 days';
    case PeriodType.Last_30Days:
      return 'Last 30 days';
    case PeriodType.Last_90Days:
      return 'Last 90 days';
    case PeriodType.Last_180Days:
      return 'Last 180 days';
    case PeriodType.Last_365Days:
      return 'Last 365 days';
    case PeriodType.Custom:
      return 'Custom range';
    default:
      return 'Select period';
  }
};
